import { render, staticRenderFns } from "./TabStateLabel.vue?vue&type=template&id=45319dda&"
import script from "./TabStateLabel.vue?vue&type=script&lang=ts&"
export * from "./TabStateLabel.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports